/**
 * Simulationsdatum im Testsystem (docs/simulation-plan.md).
 *
 * Der API-Client schickt den gewählten Standort als `X-Sidigo-Standort` mit. Ist der
 * Standort vorgespult, rechnet das Backend für den Request mit dessen Datum und
 * antwortet mit `X-Sidigo-Simuliert-Bis`. Das hier merkt sich beides, damit das
 * Layout ein Banner zeigen kann.
 */
import { useSyncExternalStore } from 'react';

export const STANDORT_HEADER = 'X-Sidigo-Standort';
export const SIMULIERT_BIS_HEADER = 'X-Sidigo-Simuliert-Bis';

let aktiverStandortId: number | null = null;
let simuliertBis: string | null = null;
const hörer = new Set<() => void>();

export function setAktiverStandort(id: number | null): void {
  if (aktiverStandortId === id) return;
  aktiverStandortId = id;
  // Bis zur nächsten Antwort ist offen, ob der neue Standort simuliert ist.
  meldeSimuliertBis(null);
}

export function aktiverStandort(): number | null {
  return aktiverStandortId;
}

export function meldeSimuliertBis(wert: string | null): void {
  if (simuliertBis === wert) return;
  simuliertBis = wert;
  hörer.forEach((h) => h());
}

function abonnieren(h: () => void): () => void {
  hörer.add(h);
  return () => hörer.delete(h);
}

/** `YYYY-MM-DD`, wenn der gewählte Standort simuliert ist, sonst `null`. */
export function useSimuliertBis(): string | null {
  return useSyncExternalStore(abonnieren, () => simuliertBis, () => null);
}
